import { Component, OnInit, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialog } from '@angular/material/dialog';

import { InsuranceService } from '../insurance.service';

@Component({
  selector: 'app-insurance-create-carrier',
  templateUrl: './insurance-create-carrier.component.html',
  styleUrls: ['./insurance-create-carrier.component.css']
})
export class InsuranceCreateCarrierComponent implements OnInit {

  dataPatientInsuranceDetails: any = {
    PatientId: '',
    InsuranceID: '',
    EmployerNO: '',
    GroupNO: '',
    InsuranceOrder: 0,
    CoverageStart: new Date(),
    CoverageEnd: '0001-01-01T00:00:00',
    PatientInsuranceNO: ''
  };

  dataPatientInsurance: any;

  constructor(
    private dialogRef: MatDialogRef<InsuranceCreateCarrierComponent>,
    private dialog: MatDialog,
    private insuranceService: InsuranceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {

    this.dataPatientInsuranceDetails.PatientId = this.data.dataPatient.PatientId;
    this.dataPatientInsuranceDetails.InsuranceID = this.data.carrierDetails.InsuranceID;
    this.dataPatientInsuranceDetails.EmployerNO = this.data.carrierDetails.EmployerNO;
    this.dataPatientInsuranceDetails.GroupNO = this.data.carrierDetails.GroupNO;
  }

  createDataPatientInsurance() {

    this.insuranceService.createDataPatientInsurance(this.dataPatientInsuranceDetails)
      .subscribe(response => {
        this.dataPatientInsurance = response;
        this.closeRef();
      }, err => {
        console.log(err);
      });


  }

  closeRef() {
    this.dialogRef.close(this.dataPatientInsurance);
  }

}
